import React from 'react';

// Shown by the staff-only gate (./staffAccess.js) instead of a second redirect when this tab has just come back
// from V2's login — so a misconfigured hand-off never becomes a redirect loop.
const StaffOnlyNotice = ({ url }) => (
  <div
    role="alert"
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 100000,
      background: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      textAlign: 'center',
    }}
  >
    <div style={{ maxWidth: 480, fontSize: 18, lineHeight: 1.5 }}>
      <p>The iAngels investor platform has moved.</p>
      <p>
        Please sign in at <a href={url}>{url.replace(/^https?:\/\//, '')}</a>.
      </p>
      <p style={{ fontSize: 14, color: '#666' }}>
        Need help? <a href="mailto:backoffice@iangels.com">backoffice@iangels.com</a>
      </p>
    </div>
  </div>
);

export default StaffOnlyNotice;
